import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminPanel = () => {
  const { user } = useAuth();

  const adminSections = [
    {
      title: 'User Management',
      icon: 'ti-users',
      description: 'Manage system users, roles, and permissions',
      link: '/admin/users',
      color: 'bg-blue-50 border-blue-200'
    },
    {
      title: 'Product Management',
      icon: 'ti-package',
      description: 'Manage product catalog and pricing',
      link: '/admin/products',
      color: 'bg-green-50 border-green-200'
    },
    {
      title: 'Vendor Management',
      icon: 'ti-building-store',
      description: 'Manage vendor and supplier information',
      link: '/admin/vendors',
      color: 'bg-purple-50 border-purple-200'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Admin Panel</h1>
        <p className="text-gray-600 mt-1">
          Welcome back, {user?.fullName}. Manage your system settings here.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {adminSections.map((section) => (
          <Link
            key={section.title}
            to={section.link}
            className={`block p-6 rounded-lg border-2 ${section.color} hover:shadow-lg transition-all hover:scale-[1.02]`}
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-white rounded-lg shadow-sm">
                <i className={`ti ${section.icon} text-2xl text-gray-700`} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{section.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{section.description}</p>
                <span className="inline-block mt-3 text-sm font-medium text-teal-600">
                  Manage →
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Quick Stats */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <p className="text-sm text-gray-600">Total Users</p>
          <p className="text-2xl font-bold text-gray-900">-</p>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <p className="text-sm text-gray-600">Total Products</p>
          <p className="text-2xl font-bold text-gray-900">-</p>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <p className="text-sm text-gray-600">Total Vendors</p>
          <p className="text-2xl font-bold text-gray-900">-</p>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;